export default __webpack_public_path__ + "static/media/Resource-Icons-1to2-transparent.073a8a71.png";